import GrayBtn from "../../Atoms/Buttons/GrayBtn";
import styled from "styled-components";
import useMediaQuery from "../../../Hooks/useMediaQuery";
import CheckBox from "../../Atoms/CheckBox/CheckBox";

const Container = styled.div`
    margin: auto;
    width: 328px;
    display: flex;
    flex-direction: column;
    align-item: center;
`

const CheckList = styled.div`
    width: 328px;
  height: 48px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-radius: 8px;
  span {
  white-space: nowrap;
      font-family: 'Pretendard';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 140%;
      /* or 22px */

      text-align: center;

      /* Gray/Gray100 [day] */

      color: #141617;
  }
`

export default ({selections, checkList}) => {
    return (
        <Container className={"btn-container"} ref={checkList}>
            {selections.map((selection, idx) =>
                <CheckList className={"check-list"} key={idx + "checkbox"}>
                    <CheckBox
                        value={selection.value}
                        name={selection.name}
                    />
                    <span>
                            {selection.text}
                        </span>
                </CheckList>)
            }
        </Container>
    )
}
